export { CarigamiGarantie } from './components';
